/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExchangeGridModel { 
    /**
     * Id
     */
    id: number;
    /**
     * Document class id
     */
    docClass: number;
    /**
     * Document folder id
     */
    folder: number;
    /**
     * Date of creation
     */
    theDate: string;
    /**
     * Date of rate
     */
    dateRate: string;
    /**
     * Curency name for sell
     */
    sell: string;
    /**
     * Curency name for buy
     */
    buy?: string | null;
    /**
     * Amount to sell
     */
    amountToSell: number;
    /**
     * Amount to buy
     */
    amountToBuy: number;
    /**
     * Currency id for sell
     */
    sellCurrencyId: number;
    /**
     * Currency id for buy
     */
    buyCurrencyId?: number;
    /**
     * Amount BC
     */
    amountBC?: number;
    /**
     * From account id
     */
    fromAccountId: number;
    /**
     * To account id
     */
    toAccountId: number;
    /**
     * From account name
     */
    fromAccount: string;
    /**
     * From account description
     */
    fromAccDescription: string;
    /**
     * To account
     */
    toAccount: string;
    /**
     * From account account type
     */
    fromAccountAccType: number;
    /**
     * To account account type
     */
    toAccountAccType: number;
    /**
     * Fixed write of amount
     */
    fixedWriteOfAmount?: number;
    /**
     * Cash description id
     */
    cashDescId?: number;
    /**
     * Amount in
     */
    amountIn?: number;
    /**
     * Rate type id
     */
    rateTypeId: number;
    /**
     * Rate
     */
    rate: number;
    /**
     * Rate profit
     */
    rateProfit?: number;
    /**
     * Actual rate
     */
    actualRate: number;
    /**
     * Reverse rate
     */
    reverseRate: number;
    /**
     * Document number
     */
    docNumber?: number;
    /**
     * Info
     */
    info?: string | null;
    /**
     * Admin user
     */
    aUser: string;
    /**
     * Hex color without #
     */
    fontColor: string;
    /**
     * Font style
     */
    fontStyle?: string | null;
    /**
     * Allow modify
     */
    allowModify: boolean;
    /**
     * Folder name
     */
    folderName: string;
    /**
     * Amount includes tariff
     */
    amountIncludesTariff: boolean;
    /**
     * Manualy Specified Tariff
     */
    manualySpecifiedTariff: boolean;
    /**
     * Manualy Tariff amount
     */
    manualTariffAmount?: number;
    /**
     * Buy or sell
     */
    buySell?: string | null;
    /**
     * System branch id
     */
    sysBranchId?: number;
    /**
     * System branch code
     */
    sysBranchCode?: string | null;
}

